module.exports = __webpack_public_path__ + "img/telegram.22c6ce97.svg";